import React, { useState } from 'react';
import { GQLParty } from '@jewelutions/core-crm-server-api-client-domain';

import { ErrorComponent, LoadingSpinner } from '../../../../components';

import MerchantChannelCollectionAvailability from './MerchantChannelCollectionAvailability';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { MerchantNavigation } from '../../navigation/MerchantNavigation';
import { useRouteMatch } from 'react-router-dom';
import { Exception } from '@jewelutions/core-common-domain';
import { Box } from '../../../../types-hack';

interface IProps {
  party: GQLParty;
}

const MerchantChannelCollectionSettings: React.FC<IProps> = ({ party }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);

  const {
    collectionId,
    merchantChannelCatalogId
  } = MerchantNavigation.merchantChannelCatalogCollectionSettings.paramsFromPath(useRouteMatch());

  const {
    loading,
    error,
    data,
    refetch
  } = GQLOperationBuilder.merchantChannelCatalog.getMerchantChannelCatalog({
    merchantChannelCatalogId: merchantChannelCatalogId
  });

  if (loading) return <LoadingSpinner />;
  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        callback={refetch}
        message={error.message}
        details={error?.stack}
      />
    );

  const merchantChannelCollection = GQLOperationBuilder.merchantChannelCatalog
    .merchantChannelCatalogFromResponse(data)
    .availableCollections.find(c => c.id === collectionId);
  if (merchantChannelCollection === undefined)
    throw new Exception(`Merchant Channel catalog does not contain collection ${collectionId}`);

  return (
    <Box pb={10}>
      <MerchantChannelCollectionAvailability party={party} merchantChannelCollection={merchantChannelCollection} />
    </Box>
  );
};

export default MerchantChannelCollectionSettings;
